import { useDocumentUploader } from '@/hooks/useDocumentUploader'
import {
  IDocumentsFormValues,
  IUploaderProps,
  TUploadedFile
} from '@/types/uploader'
import { Alert } from '@dgshahr/ui-kit'
import FileUploader, { FileType } from '@dgshahr/ui-kit/Form/FileUploader'

const OfficialNewspaper = ({ formik, corrections }: IUploaderProps) => {
  const { values } = formik
  const { handleUpload, handleDelete } = useDocumentUploader(formik)

  const fieldName = 'OFFICIAL_NEWSPAPER'

  const handleChange = (file: File | undefined) =>
    file && handleUpload(fieldName, file)

  const handleDeleteFile = (
    fieldName: keyof IDocumentsFormValues,
    e: TUploadedFile
  ): void => {
    handleDelete(fieldName, e)
  }

  return (
    <div className="flex flex-col gap-8">
      {corrections?.[fieldName] && (
        <div className="flex flex-col gap-4">
          <Alert
            size="small"
            title="اصلاحیه‌"
            variant="error"
            text={corrections[fieldName].comment}
          />
        </div>
      )}
      <div className="rtl text-right">
        <label
          htmlFor="official-newspaper"
          className="font-p2-medium text-gray-500"
        >
          آگهی‌های روزنامه رسمی را بارگذاری کنید، شامل تمام موارد موجود:{' '}
        </label>
        <ul className="list-disc list-inside mt-2">
          <li className="font-p2-medium text-gray-500">
            اولین روزنامه رسمی (تاسیس)
          </li>
          <li className="font-p2-medium text-gray-500">
            آخرین روزنامه تغییرات شرکت
          </li>
          <li className="font-p2-medium text-gray-500">
            آخرین روزنامه تغییرات هیئت مدیره
          </li>
        </ul>
      </div>

      <FileUploader
        className="w-fit"
        fileInputProps={{
          id: 'official-newspaper',
          className: 'ss02',
          description: 'فرمت‌های قابل قبول PNG , SVG یا PDF\nحداکثر حجم تا 5Mb',
          helperProps: {
            hintMessage: ''
          },
          title: 'روزنامه رسمی',
          accept:
            'image/png, image/jpeg, image/jpg, image/PNG, image/JPEG, image/JPG , application/pdf'
        }}
        mode="multiple"
        files={values[fieldName] as FileType[]}
        onChange={handleChange}
        previewProps={{
          leftButton: {
            onClick: (e) => handleDeleteFile(fieldName, e as TUploadedFile)
          },
          rightButton: false
        }}
      />
    </div>
  )
}

export default OfficialNewspaper
